import { platform } from '@/shared/lib/platform/platform'

const PREFS_STORAGE_PREFIX = 'synap:prefs:'

const webStorageKey = (key: string): string => `${PREFS_STORAGE_PREFIX}${key}`

/** Preferências persistidas (Preferences nativo; localStorage namespaced na PWA). */
export const prefs = {
  get: async (key: string): Promise<string | null> => {
    if (platform.isNative()) {
      const { Preferences } = await import('@capacitor/preferences')
      const { value } = await Preferences.get({ key })
      return value
    }
    return localStorage.getItem(webStorageKey(key))
  },

  set: async (key: string, value: string): Promise<void> => {
    if (platform.isNative()) {
      const { Preferences } = await import('@capacitor/preferences')
      await Preferences.set({ key, value })
      return
    }
    localStorage.setItem(webStorageKey(key), value)
  },

  remove: async (key: string): Promise<void> => {
    if (platform.isNative()) {
      const { Preferences } = await import('@capacitor/preferences')
      await Preferences.remove({ key })
      return
    }
    localStorage.removeItem(webStorageKey(key))
  },
}
